
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function TermosDeUsoPage() {
  const sections = [
    {
      icon: 'ri-file-text-line',
      title: '1. Aceitação dos Termos',
      content: `Ao acessar ou utilizar o site e os serviços da ViaEducacaoCursos, você concorda com estes Termos de Uso. Caso não concorde com qualquer disposição, pedimos que não utilize nossos serviços.

Estes Termos constituem um acordo legal entre você (usuário) e a Vrc Programas Treinamentos e Cursos Educacionais Ltda, CNPJ 62.934.863/0001-93, proprietária da marca ViaEducacaoCursos.`
    },
    {
      icon: 'ri-building-line',
      title: '2. Sobre a Empresa',
      content: `A ViaEducacaoCursos é uma plataforma de educação online especializada em capacitação de educadores por meio de cursos, mentorias, consultorias e programas de inteligência artificial aplicada ao ensino.

Razão Social: Vrc Programas Treinamentos e Cursos Educacionais Ltda
CNPJ: 62.934.863/0001-93
Marca: ViaEducacaoCursos
Contato: contato@viaeducacaocursos.com.br`
    },
    {
      icon: 'ri-book-open-line',
      title: '3. Serviços Oferecidos',
      content: `A ViaEducacaoCursos oferece:

• Cursos online gravados e ao vivo sobre inteligência artificial aplicada à educação;
• Programas de mentoria individual e em grupo;
• Serviços de consultoria para instituições de ensino;
• Programas de agentes de IA para educadores;
• Materiais educativos complementares;
• Comunidade de aprendizado e suporte via WhatsApp.

Os serviços podem ser alterados, suspensos ou encerrados a qualquer momento, com aviso prévio sempre que possível.`
    },
    {
      icon: 'ri-user-settings-line',
      title: '4. Cadastro e Conta do Usuário',
      content: `Para acessar determinados serviços, você precisará criar uma conta. Ao se cadastrar, você se compromete a:

• Fornecer informações verdadeiras, precisas e atualizadas;
• Manter a confidencialidade de sua senha e dados de acesso;
• Notificar imediatamente qualquer uso não autorizado de sua conta;
• Ser responsável por todas as atividades realizadas em sua conta.

A ViaEducacaoCursos reserva-se o direito de suspender ou encerrar contas que violem estes Termos.`
    },
    {
      icon: 'ri-shopping-cart-line',
      title: '5. Compras e Pagamentos',
      content: `As compras realizadas em nossa plataforma estão sujeitas às seguintes condições:

• Os preços são exibidos em Reais (BRL) e podem ser alterados sem aviso prévio;
• O pagamento é processado por plataformas parceiras seguras (Hotmart, Kiwify, etc.);
• Após a confirmação do pagamento, o acesso ao conteúdo é liberado em até 24 horas;
• Parcelamentos estão sujeitos às condições da operadora de cartão ou plataforma de pagamento;
• Promoções e descontos são válidos apenas pelo período indicado.`
    },
    {
      icon: 'ri-refund-2-line',
      title: '6. Política de Reembolso e Garantia',
      content: `Oferecemos garantia de satisfação em nossos produtos:

• **Garantia de 15 dias:** Para a maioria dos cursos, você tem 15 dias corridos a partir da data de compra para solicitar reembolso integral, sem necessidade de justificativa.
• **Como solicitar:** Envie um e-mail para contato@viaeducacaocursos.com.br com o assunto "Solicitação de Reembolso" e o número do pedido.
• **Prazo de devolução:** O reembolso é processado em até 10 dias úteis após a aprovação.
• **Exceções:** Programas de mentoria e consultoria com sessões já realizadas podem ter condições específicas informadas no momento da contratação.

Esta garantia está em conformidade com o Código de Defesa do Consumidor (Lei nº 8.078/1990).`
    },
    {
      icon: 'ri-copyright-line',
      title: '7. Propriedade Intelectual',
      content: `Todo o conteúdo disponibilizado na plataforma ViaEducacaoCursos é protegido por direitos autorais e demais leis de propriedade intelectual, incluindo:

• Vídeos, aulas e materiais didáticos;
• Textos, imagens, logotipos e identidade visual;
• Metodologias, frameworks e materiais exclusivos.

É expressamente proibido:

• Reproduzir, distribuir ou compartilhar o conteúdo sem autorização prévia por escrito;
• Gravar, baixar ou redistribuir aulas e materiais;
• Utilizar o conteúdo para fins comerciais sem licença;
• Remover marcas d\'água ou identificações de autoria.

Violações estão sujeitas às penalidades previstas na Lei nº 9.610/1998 (Lei de Direitos Autorais).`
    },
    {
      icon: 'ri-prohibited-line',
      title: '8. Uso Proibido',
      content: `É vedado ao usuário:

• Utilizar os serviços para fins ilegais ou não autorizados;
• Tentar acessar áreas restritas da plataforma sem autorização;
• Compartilhar credenciais de acesso com terceiros;
• Publicar conteúdo ofensivo, discriminatório ou que viole direitos de terceiros;
• Realizar engenharia reversa ou tentativas de invasão;
• Utilizar bots, scrapers ou ferramentas automatizadas sem autorização;
• Praticar qualquer ato que prejudique o funcionamento da plataforma ou outros usuários.`
    },
    {
      icon: 'ri-alert-line',
      title: '9. Limitação de Responsabilidade',
      content: `A ViaEducacaoCursos não se responsabiliza por:

• Resultados específicos decorrentes da aplicação dos conteúdos ensinados, pois dependem do esforço e contexto de cada aluno;
• Interrupções temporárias no acesso à plataforma por manutenção ou fatores externos;
• Danos causados por uso indevido da plataforma pelo próprio usuário;
• Conteúdo de sites de terceiros vinculados por links em nossa plataforma.

Nossa responsabilidade está limitada ao valor pago pelo serviço contratado.`
    },
    {
      icon: 'ri-map-pin-line',
      title: '10. Lei Aplicável e Foro',
      content: `Estes Termos de Uso são regidos pelas leis da República Federativa do Brasil. Fica eleito o foro da comarca do domicílio do consumidor para dirimir quaisquer controvérsias decorrentes deste instrumento, conforme previsto no Código de Defesa do Consumidor.

Antes de qualquer medida judicial, encorajamos a resolução amigável de conflitos por meio do nosso canal de atendimento: contato@viaeducacaocursos.com.br`
    },
    {
      icon: 'ri-refresh-line',
      title: '11. Alterações nos Termos',
      content: `A ViaEducacaoCursos reserva-se o direito de modificar estes Termos a qualquer momento. As alterações entram em vigor imediatamente após a publicação no site.

Recomendamos que você revise periodicamente esta página. O uso continuado dos serviços após as alterações implica na aceitação dos novos Termos.

Mudanças significativas serão comunicadas por e-mail ou por aviso em destaque no site.`
    }
  ];

  const lastUpdate = '15 de junho de 2025';

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        {/* Hero */}
        <section className="pt-32 pb-16 bg-gradient-to-b from-slate-50 to-white">
          <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-slate-100 rounded-full text-slate-600 text-sm font-medium mb-6">
              <i className="ri-file-list-3-line"></i>
              Última atualização: {lastUpdate}
            </div>
            <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6 leading-tight">
              Termos de Uso
            </h1>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto leading-relaxed">
              Leia atentamente os termos e condições que regem o uso dos serviços e da plataforma ViaEducacaoCursos.
            </p>
          </div>
        </section>

        {/* Content */}
        <section className="pb-24">
          <div className="max-w-4xl mx-auto px-6 lg:px-8">

            {/* Intro card */}
            <div className="bg-gradient-to-r from-slate-800 to-slate-900 rounded-2xl p-8 mb-12 text-white">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-white/10 rounded-xl flex-shrink-0">
                  <i className="ri-information-line text-2xl text-white"></i>
                </div>
                <div>
                  <h2 className="text-xl font-bold mb-2">Resumo Rápido</h2>
                  <p className="text-slate-300 leading-relaxed text-sm">
                    Ao usar nossos serviços, você concorda com estes termos. Oferecemos <strong className="text-white">garantia de 15 dias</strong> em nossos cursos. Todo o conteúdo é protegido por direitos autorais. Dúvidas? Fale conosco em <strong className="text-white">contato@viaeducacaocursos.com.br</strong>
                  </p>
                </div>
              </div>
            </div>

            {/* Sections */}
            <div className="space-y-8">
              {sections.map((section, index) => (
                <div key={index} className="bg-white border border-gray-100 rounded-2xl p-8 shadow-sm hover:shadow-md transition-shadow duration-300">
                  <div className="flex items-center gap-4 mb-5">
                    <div className="w-11 h-11 flex items-center justify-center bg-slate-100 rounded-xl flex-shrink-0">
                      <i className={`${section.icon} text-xl text-slate-700`}></i>
                    </div>
                    <h2 className="text-xl font-bold text-gray-900">{section.title}</h2>
                  </div>
                  <div className="text-gray-600 leading-relaxed text-sm">
                    {section.content.split('\n').map((line, i) => {
                      if (line.startsWith('• **') && line.includes(':**')) {
                        const parts = line.replace('• **', '').split(':**');
                        return (
                          <p key={i} className="mb-2 flex items-start gap-2">
                            <span className="text-slate-400 mt-0.5">•</span>
                            <span><strong className="text-gray-800">{parts[0]}:</strong>{parts[1]}</span>
                          </p>
                        );
                      }
                      if (line.startsWith('• ')) {
                        return (
                          <p key={i} className="mb-2 flex items-start gap-2">
                            <span className="text-slate-400 mt-0.5">•</span>
                            <span>{line.replace('• ', '')}</span>
                          </p>
                        );
                      }
                      if (line.trim() === '') return <div key={i} className="mb-3"></div>;
                      return <p key={i} className="mb-3">{line}</p>;
                    })}
                  </div>
                </div>
              ))}
            </div>

            {/* Contact */}
            <div className="mt-12 bg-gradient-to-br from-slate-50 to-slate-100 rounded-2xl p-8 text-center border border-slate-200">
              <div className="w-14 h-14 flex items-center justify-center bg-slate-800 rounded-full mx-auto mb-4">
                <i className="ri-customer-service-2-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Ficou com alguma dúvida?</h3>
              <p className="text-gray-600 text-sm mb-4">
                Nossa equipe está pronta para te ajudar. Entre em contato:
              </p>
              <a
                href="mailto:contato@viaeducacaocursos.com.br"
                className="inline-flex items-center gap-2 px-6 py-3 bg-slate-800 text-white text-sm font-medium rounded-full hover:bg-slate-700 transition-colors duration-300 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-mail-send-line"></i>
                contato@viaeducacaocursos.com.br
              </a>
              <p className="text-xs text-gray-500 mt-4">
                Vrc Programas Treinamentos e Cursos Educacionais Ltda — CNPJ 62.934.863/0001-93
              </p>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
